import React from "react";
import styled from "styled-components";
import { Space } from "antd";

import Button from "modules/Common/Components/Button";
import PopoverCard from "./PopoverCard";
import Roy from "../../../assets/img/icons/roy.svg";
import CrossGreen from "../../../assets/img/icons/crossGreen.svg";

interface popoverDataProps {
  crossClickHandler?: () => void;
}

const popoverData: React.FC<popoverDataProps> = (props) => {
  return (
    <Wrapper>
      <div className="d-flex align-items-center justify-content-between heading-main-green">
        <div>
          <img style={{ width: 55, height: 25, marginLeft: 5 }} src={Roy} />
          xiQ intelligent assistant
        </div>
        <div>
          <img
            onClick={props.crossClickHandler}
            style={{ width: 25, height: 25, marginRight: 10, cursor: "pointer" }}
            src={CrossGreen}
          />
        </div>
      </div>
      <div className="padding-content">
        <div>
          <h1 className="heading-styling1">It's that time again!</h1>
          <h1 className="heading-styling2">Curate new content to share with:</h1>
        </div>
        <div className="d-flex justify-content-center">
          <PopoverCard dateRed="14 days ago" dateGrey="7 days ago" />
        </div>
        <div className="paragraph-styling">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
          dolore magna aliqua.
        </div>
        <div className="d-flex justify-content-center">
          <Space>
            <Button className="btn-sm-secondary" secondary value="Curate later" />
            <Button className="btn-sm-primary" value="Curate now" />
          </Space>
        </div>
      </div>
    </Wrapper>
  );
};

export default popoverData;

const Wrapper = styled.div`
  .padding-content {
    padding: 0 25px 25px 25px;
  }
  .heading-main-green {
    height: 50px;
    background-color: rgba(39, 206, 10, 0.15);
    margin-bottom: 10px;
    border-radius: 15px 15px 0 0;
    color: rgb(9, 164, 58);
    font-size: 18px;
    font-weight: 500;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
    img {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 20px !important;
        margin: 0 10px;
      }
    }
  }
  .heading-styling1 {
    font-size: 30px;
    line-height: 1.067;
    color: #09a43a;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 22px;
    }
  }
  .heading-styling2 {
    font-size: 30px;
    line-height: 1.067;
    color: #424b50;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 22px;
    }
  }
  .paragraph-styling {
    margin: 1em 0 1.5em 0;
    color: #7e7e7e;
    font-size: 16px;
    font-weight: 500;
    font-family: "robotomedium";
    line-height: 1.25;
    text-align: justify;
    text-justify: inter-word;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
`;
